const SENSITIVE_PROPERTY_KEY_PATTERN = /(?:^|_)(?:email|e-mail|phone|telephone|password|passcode|token|secret|address|street|zip|postal|card|pan|cvv|cvc|ssn|error_message|error_stack|exception)(?:$|_)/i;

const isSensitivePropertyKey = (key) => SENSITIVE_PROPERTY_KEY_PATTERN.test(key);

/**
 * Applies the shared browser/mobile event envelope and removes direct PII and
 * credential fields before they can leave a client surface.
 */
export function prepareClientAnalyticsProperties(
  properties = {},
  { appName, eventVersion = 1, now = new Date() },
) {
  const safeProperties = Object.fromEntries(
    Object.entries(properties).filter(([key]) => !isSensitivePropertyKey(key)),
  );

  if (
    typeof safeProperties.organization_id !== 'string' &&
    typeof safeProperties.organizationId === 'string'
  ) {
    safeProperties.organization_id = safeProperties.organizationId;
  }

  return {
    ...safeProperties,
    app_name: appName,
    event_version: eventVersion,
    client_timestamp: now.toISOString(),
  };
}

/**
 * Captures client interaction telemetry without ever allowing analytics to
 * interrupt the originating product flow.
 */
export function captureClientEvent(posthog, eventName, properties = {}, options) {
  if (!posthog?.capture || !eventName.trim() || !options?.appName) return;

  try {
    const captureResult = posthog.capture(
      eventName,
      prepareClientAnalyticsProperties(properties, options),
    );
    if (captureResult?.catch) {
      void captureResult.catch(() => undefined);
    }
  } catch {
    // Analytics must remain non-blocking on every client surface.
  }
}
